import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {TreatmentSummaryModel} from '../model/treatmentSummary.model';
import {FormSummaryConverter} from '../../../../../form/form/api/entity/converter/formSummary.converter';
import {DateConverter} from '../../../../../common/converter/date.converter';
import {ValueAndLabelConverter} from '../../../../../common/converter/ValueAndLabel.converter';
import {
    TreatmentFeedbackSummaryConverter
} from '../../../treatment-feedback/api/models/converter/treatment-feedback.summary.converter';


@Injectable({providedIn: 'root'})
export class TreatmentSummaryConverter extends HttpModelConverter<TreatmentSummaryModel> {

    constructor(private formSummaryConverter: FormSummaryConverter,
                private treatmentFeedbackSummaryConverter: TreatmentFeedbackSummaryConverter ) {
        super();
    }

    protected createInstance(): TreatmentSummaryModel {
        return new TreatmentSummaryModel();
    }

    protected enrichObject(result: TreatmentSummaryModel, src: TreatmentSummaryModel) {
        result.form = this.formSummaryConverter.convert(src.form);
        result.startDate = new DateConverter().convert(src.startDate);
        result.plannedStartDate = new DateConverter().convert(src.plannedStartDate);
        result.endDate = new DateConverter().convert(src.endDate);
        result.plannedEndDate = new DateConverter().convert(src.plannedEndDate);
        result.cancelDate = new DateConverter().convert(src.cancelDate);
        result.status = new ValueAndLabelConverter().convert(src.status);
        result.lastFeedback = this.treatmentFeedbackSummaryConverter.convert(src.lastFeedback);
    }
}
